import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useState } from 'react';
import EcommerceProductView from './EcommerceProductView';
import { getListingContactData } from '../../utils/hooks';
import { extractYachtAndContactsFromListingData } from '../../utils/transformers';

const EcommerceProductViewWrapper = ({ parent: { itemId, itemEntity }, router }) => {
  const { asPath } = router;
  const [currentLocation, setCurrentLocation] = useState('');

  const data = getListingContactData(itemEntity, itemId);
  if (!data) {
    return null;
  }

  const yachtAndContacts = extractYachtAndContactsFromListingData(itemEntity, data);
  if (!yachtAndContacts) return null;

  if (currentLocation !== asPath) {
    setCurrentLocation(asPath);
    return null;
  }

  return (
    <EcommerceProductView
      contacts={yachtAndContacts.contacts}
      currentLocation={currentLocation}
      yachtData={yachtAndContacts.yachtData}
    />
  );
};

EcommerceProductViewWrapper.propTypes = {
  router: PropTypes.object.isRequired,
  parent: PropTypes.object.isRequired
};

export default withRouter(EcommerceProductViewWrapper);
